export const OPEN_ACTIVITY_QUICK_VIEW_MODAL = 'OPEN_ACTIVITY_QUICK_VIEW_MODAL';
export const OPEN_PORTAL_USERS_PANEL = 'OPEN_PORTAL_USERS_PANEL';
export const UPDATE_BIZ_OPS_STORES = 'UPDATE_BIZ_OPS_STORES';